import {
  CATEGORIES_PATH,
  SEARCH_PATH,
  TMultiPageRouteParams,
} from '@/_constants/routes';
import { EPageType } from '@/_analytic/_types';

type TProps = {
  params: TMultiPageRouteParams;
  pathname: string;
};

export const getPageType = ({ params, pathname }: TProps): EPageType => {
  const { parentCategoryId, childCategoryId, materialId } = params;
  const isSearchPage = pathname.includes(SEARCH_PATH);
  if (isSearchPage) {
    return EPageType.SEARCH;
  }

  const isCategoryChild = pathname.includes(CATEGORIES_PATH);

  if (materialId) {
    return EPageType.ARTICLE;
  }

  if (childCategoryId) {
    return EPageType.SUBSECTION;
  }

  if (parentCategoryId) {
    return EPageType.SECTION;
  }

  if (isCategoryChild) {
    return EPageType.MAIN_PAGE;
  }

  return EPageType.ADVICE_LIST;
};
